<template>
  <div class="home">
    <Hero
      title="Faça parte do melhor escritório de <br /> Propriedade Intelectual do Brasil!"
      image="banner.jpg"
      height="77vh"
      :searchBox="true"
    />
    <WhoWeAre />
    <Area />
    <Faq />
  </div>
</template>

<script>
// @ is an alias to /src
import Hero from "@/components/media/Hero.vue";
import Slider from "@/components/media/Slider.vue";
import Gallery from "@/components/media/Gallery.vue";
import Faq from "@/components/Faq.vue";
//Components
import Area from "@/views/home/components/Area.vue";
import MissionValues from "@/views/home/components/MissionValues.vue";
import WhoWeAre from "@/views/home/components/WhoWeAre.vue";
export default {
  name: "Home",

  data() {
    return {};
  },

  head() {
    return this.$head({
      title: ""
    });
  },

  computed: {
    valores() {
      return this.$store.state.values;
    },

    teams() {
      return this.$store.state.teams;
    },

    conquistas() {
      return this.$store.state.conquistas;
    },

    faqItems() {
      return this.$store.state.faqItems;
    }
  },

  components: {
    Hero,
    Slider,
    Gallery,
    Faq,
    Area,
    MissionValues,
    WhoWeAre
  },

  mounted() {
    this.$store.dispatch("opportunities/setOpportunities");
  }
};
</script>
